import { Group, Text, Tooltip } from '@mantine/core';
import { CircleHelp } from 'lucide-react';

type StatHelpProps = {
  label: string;
  description: string;
};

export function StatHelp({ label, description }: StatHelpProps) {
  return (
    <Group gap={6} wrap='nowrap'>
      <Text size='sm' fw={500}>
        {label}
      </Text>
      <Tooltip multiline w={280} label={description}>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'help',
            color: 'var(--mantine-color-dimmed)',
          }}
        >
          <CircleHelp size={14} />
        </span>
      </Tooltip>
    </Group>
  );
}
